import moment from "moment";
import {
  API_RESPONSE_CODE,
  CLICK_ACTIONS,
  LINE_OF_BUSINESS,
  PRODUCT_LOB_MAPPING,
  STATUS,
  STORAGE_KEY,
} from "./Constant";
import { ColumnHeaderType, LoggedUserType } from "./Types";
import {
  mapGrievanceModeMaster,
  mapGrievanceSourceMaster,
  mapGrievanceTypeMaster,
  mapMasters,
  mapLOBMaster,
  mapRequestTypeMaster,
  mapStatusMaster 
} from "./MastersMapping";

export const isValidString = (value?: string | number) => {
  if (!value || value === "null" || value === "undefined") {
    return false;
  } else if (String(value).replaceAll(" ", "").length === 0) {
    return false;
  }
  return true;
};
const replaceStringAt = (text: string, index: number, replaceWith: string) => {
  if (index > text.length - 1) return text;
  return text.substring(0, index) + replaceWith + text.substring(index + 1);
};

export const arrayToFormattedString = (array: string[]) => {
  if (!array || array.length === 0) {
    return "-";
  }
  let commaSeparated = array.join(", ");
  if (array.length > 1) {
    commaSeparated = replaceStringAt(
      commaSeparated,
      commaSeparated.lastIndexOf(","),
      " &"
    );
  }
  return commaSeparated;
};

export const stringToFormattedString = (text: string) => {
  if (!isValidString(text)) {
    return "-";
  }
  if (text.indexOf(",") === -1) {
    return text;
  } else {
    return replaceStringAt(text, text.lastIndexOf(","), " &");
  }
};

export const checkNullValue = (value?: string | number) => {
  if (!isValidString(value)) {
    return "N/A";
  }
  return value;
};
export const getBlankValueIfNUll = (value?: string | number) => {
  if (!isValidString(value)) {
    return "";
  }
  return value;
};

export const formattedDate = (inputDate: string) => {
  if (!inputDate || inputDate === "null") return "N/A";
  return moment(inputDate).format("DD-MM-YYYY");
};

export const nameValueGetter = (data: any, field?: string) => {
  return checkNullValue(
    `${getBlankValueIfNUll(data.firstName)} ${getBlankValueIfNUll(
      data.lastName
    )}`
  );
};
export const nameValueGetterSmall = (data: any, field?: string) => {
  return checkNullValue(
    `${getBlankValueIfNUll(data.firstname)} ${getBlankValueIfNUll(
      data.lastname
    )}`
  );
};
export const blankValueGetter = (data: any, field?: string) => {
  return checkNullValue(data[field as keyof any]);
};

export const groupNameGetter = (data: any, field?: string) => {
  let name = '';
  let value = data[field as keyof any];
  if(value?.length > 0){
    value.map((each: any)=>{
      name = addSeparator(name, each);
    })
    return name;
  }
  else{
    return 'N/A';
  }
}

export const policyValueGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return isValidString(data?.applicationId) ? data?.applicationId?.slice(0,19) : 'N/A';
  } else {
    return value;
  }
}

export const dateValueGetter = (data: any, field?: string) => {
  return formattedDate(String(data[field as keyof any]));
};

export const policyStardateValueGetter = (data: any, field?: string) => {
  if(isValidString(String(data[field as keyof any]))){return formattedDate(String(data[field as keyof any]));}
  else if(isValidString(String(data?.proposalIssueDate))){return formattedDate(String(data?.proposalIssueDate));}
  else { return 'N/A';}
}

export const addSeparator = (text1: string, text2: any) => {
  if (isValidString(text1) && isValidString(text2)) {
    return text1 + ", " + text2;
  } else if (isValidString(text2)) {
    return text2;
  } else if (isValidString(text1)) {
    return text1;
  } else {
    return "-";
  }
};

export const capitalizeFirstLetter = (text: string) => {
  if (!text || text === "null") {
    return "-";
  }
  return text.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};

export const saveInLocalStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
};
export const removeFromLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};
export const getFromLocalStorage = (key: string) => {
  const data = localStorage.getItem(key);
  return data ? data : "";
};

export const getAccessToken = () => {
  const data = localStorage.getItem(STORAGE_KEY.AUTH_DATA);
  if (data) {
    const user: LoggedUserType = JSON.parse(data);
    return user.accessToken;
  }
  return "";
};

export const clearSession = () => {
  sessionStorage.clear(); //clear outlook detail
};
export const getUser = (): LoggedUserType => {
  let user: LoggedUserType = {
    candidateId: 0,
    candidateUniqueId: "",
    employeeUniqueId: "",
    firstname: "",
    lastName: "",
    employeeName:"",
    userActivationStatus: 0,
    userActivationStatusName: "",
    accessToken: "",
    accessExpiryTime: "",
    resetToken: "",
    resetExpiryTime: "",
    mobileNumber: 0,
    emailId: "",
    loginType: 0,
    loginTypeName: "",
    roleId: -1,
    permissions: [],
    roleName: [],
    userId: "",
    sessionId: ''
  };
  const data = localStorage.getItem(STORAGE_KEY.AUTH_DATA);
  if (data) {
    user = JSON.parse(data);
  }
  return user;
};

export const getFormattedTime = (totalMinutes: number) => {
  if (!totalMinutes) {
    return "-";
  }
  const minutes = totalMinutes % 60;
  const hours = Math.floor(totalMinutes / 60);
  let time = "";
  if (hours) {
    time = hours + " hrs";
    if (minutes) {
      time = time + ", " + minutes + "mins";
    }
  } else {
    time = minutes + " mins";
  }
  return time;
};

export const isAPIFailed = (fulfilled: any) => {
  if (
    fulfilled.responseInformation &&
    fulfilled.responseInformation &&
    fulfilled.responseInformation.responseCode === API_RESPONSE_CODE.FAIL
  ) {
    return true;
  } else {
    return false;
  }
};
export const isAPISuccess = (fulfilled: any) => {
  if (
    fulfilled.responseInformation &&
    fulfilled.responseInformation &&
    fulfilled.responseInformation.responseCode === API_RESPONSE_CODE.SUCCESS
  ) {
    return true;
  } else {
    return false;
  }
};

export const toProperCase = (text: string) => {
  return text.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
  });
};

export const add3Dots = (text: string, limit: number) => {
  var dots = "...";
  if (!text) {
    return "-";
  }
  if (text.length > limit) {
    text = text.substring(0, limit) + dots;
  }
  return text;
};

export const canShowToolTip = (limit: number, data: any, field?: string) => {
  const email = data[field as keyof any];
  if (!email || email === "null" || email.length <= limit) {
    return false;
  } else {
    return email.length > limit;
  }
};

export const convertDate = (date: Date) => {
  const day = date.toLocaleDateString('en-GB', { day: '2-digit' });
  const month = date.toLocaleDateString('en-GB', { month: '2-digit' });
  const year = date.getFullYear();

  const hours = date.toLocaleTimeString('en-US', { hour: '2-digit', hour12: true }).split(' ')[0];
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const suffix = date.toLocaleTimeString('en-US', { hour: '2-digit', hour12: true }).split(' ')[1];

  return `${day}-${month}-${year} ${hours}:${minutes} ${suffix}`;
}

export const timeStampToDate = (date: string) => {
  let cDate = new Date(date);
  cDate.setHours(cDate.getHours() + 5, cDate.getMinutes() + 30);
  return cDate;
}

export const convertWithoutTimezone = (date: string) => {
  let cDate = new Date(date);
    cDate.setHours(cDate.getHours(), cDate.getMinutes());
  return cDate;
}

export const getCurrentDate = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const MM = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');

  return `${yyyy}-${MM}-${dd}`;
}

export const getCurrentTime = () => {
  const today = new Date();
  const hh = String(today.getHours()).padStart(2, '0')
  const mm = String(today.getMinutes()).padStart(2, '0')

  return `${hh}:${mm}`;
}

export const getCurrentDateTime = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const MM = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  const hh = String(today.getHours()).padStart(2, '0');
  const mm = String(today.getMinutes()).padStart(2, '0');

  return `${yyyy}-${MM}-${dd}T${hh}:${mm}`;
}

export const getIdByValue = (value: any, data: any) => {
  const found = data.find((item: any) => item.label === value);
  return found ? found.value : null;
}


export const formattedDateWithFormat = (
  inputDate: string,
  dateFormat: string
) => {
  if (!isValidString(inputDate) || !isValidString(dateFormat)) return '-';
  return moment(inputDate).format(dateFormat);
};

export const getTableItemClickClass = (
  item: any,
  headerItem: ColumnHeaderType
) => {
  if (
    headerItem.actionGetter &&
    headerItem.actionGetter(item, headerItem.field) === CLICK_ACTIONS.NO_ACTION
  ) {
    return '';
  } else if (
    (headerItem.action ?? headerItem.actionGetter) &&
    headerItem.clickable
  ) {
    return 'text-decoration-underline td-clickable cursor-pointer';
  } else {
    return '';
  }
};

export const departmentValueGetter = (data: any, field?: string, departmentData?: any) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return 'N/A';
  } else {
    return mapMasters(value, departmentData);
  }
};


export const userNameValueGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return 'N/A';
  } else {
    return data?.firstName + ' ' + (data?.lastName ? data?.lastName : '');
  }
}

export const roleStatusValueGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (value === null || value === undefined) {
    return 'N/A';
  } else if(value === true){
    return 'Active';
  } else {
    return 'Inactive';
  }
}

export const userStatusValueGetter = (data: any, field?: string) => {
  const groupName = data?.groupName;
  if (groupName && groupName !== "N/A" && groupName.length > 0) {
    return "Active";
  } else {
    return "Inactive";
  }
};

export const statusValueGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return 'N/A';
  } else {
    return mapStatusMaster(value);
  }
};
export const grievanceTypeValueGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return 'N/A';
  } else {
    return mapGrievanceTypeMaster(value);
  }
};
export const grievanceSourceValueGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return 'N/A';
  } else {
    return mapGrievanceSourceMaster(value);
  }
};
export const grievanceModeValueGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return 'N/A';
  } else {
    return mapGrievanceModeMaster(value);
  }
};

export const typeOfRequestValueGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return 'Grievance';
  } else {
    return mapRequestTypeMaster(value);
  }
};

export const lobValueGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return 'N/A';
  } else {
    return mapLOBMaster(value);
  }
};

export const getTATClassNameGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return "";
  } else if(data.daysSpent <= 1){
    return "tat1";
  } else if(data.daysSpent < 4 && data.daysSpent >= 2){
    return "tat2";
  } else if(data.daysSpent >= 4){
    return "tat3";
  } else{
    return "";
  }
};

export const getDepartmentClassNameGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return "";
  } else{
    return "department";
  }
};

export const getStatusClassNameGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return "";
  } else if(data.status == STATUS.CLOSE){
    return "close";
  } else if(data.status == STATUS.RESOLVE){
    return "resolve";
  } else{
    return "";
  }
};

export const paymentStatusValueGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return "N/A";
  } else if(data.paymentStatus == 1){
    return "NEW_ORDER";
  } else if(data.paymentStatus == 2){
    return "PROCESSING";
  } else if(data.paymentStatus == 3){
    return "SUCCESSFUL";
  } else if(data.paymentStatus == 4){
    return "REFUND_CREATED";
  } else if(data.paymentStatus == 5){
    return "REFUNDED";
  } else if(data.paymentStatus == 6){
    return "FAILED";
  } else{
    return "N/A";
  }
}

export const policyStatusValueGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return 'N/A';
  } else if(data.policyStatus == 1){
    return "Active";
  } else if(data.policyStatus == 2){
    return "Expired";
  } else if(data.policyStatus == 3){
    return "CANCELLATION_INITIATED";
  } else if(data.policyStatus == 4){
    return "CANCELLED";
  } else if(data.policyStatus == 5){
    return "WITHDRAWN";
  } else{
    return "N/A";
  }
}
export const kycStatusValueGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return 'N/A';
  } else if(data.ckycStatus == 0){
    return "Deleted";
  } else if(data.ckycStatus == 1){
    return "Pending";
  } else if(data.ckycStatus == 2){
    return "Approved";
  } else if(data.ckycStatus == 3){
    return "Resubmission";
  } else if(data.ckycStatus == 4){
    return "Rejected";
  } else if(data.ckycStatus == 6){
    return "Resubmission & Pending";
  } else{
    return "N/A";
  }
}
export const farmStatusValueGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return 'N/A';
  } else if(data.farmStatus == 0){
    return "Deleted";
  } else if(data.farmStatus == 1){
    return "Pending";
  } else if(data.farmStatus == 2){
    return "Approved";
  } else if(data.farmStatus == 3){
    return "Resubmission";
  } else if(data.farmStatus == 4){
    return "Rejected";
  } else if(data.farmStatus == 5){
    return "Hold";
  } else if(data.farmStatus == 6){
    return "Resubmission & Pending";
  } else{
    return "N/A";
  }
}
export const proposalStatusValueGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return 'N/A';
  } else if(data.proposalStatus == 0){
    return "Deleted";
  } else if(data.proposalStatus == 1){
    return "Pending";
  } else if(data.proposalStatus == 2){
    return "Approved";
  } else if(data.proposalStatus == 3){
    return "Resubmission";
  } else if(data.proposalStatus == 4){
    return "Rejected";
  } else if(data.proposalStatus == 5){
    return "Hold";
  } else if(data.proposalStatus == 6){
    return "Resubmission & Pending";
  } else if(data.proposalStatus == 7){
    return "Policy Generated";
  }  else{
    return "N/A";
  }
}
export const policyStatusClassGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return '';
  } else if(data.policyStatus == 3){
    return "pending-data";
  } else if(data.policyStatus == 1){
    return "approved-data";
  } else if(data.policyStatus == 2 || data.policyStatus == 4 || data.policyStatus == 5){
    return "rejected-data";
  } else{
    return "";
  }
}
export const kycStatusClassGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return '';
  } else if(data.ckycStatus == 1 || data.ckycStatus == 6){
    return "pending-data";
  } else if(data.ckycStatus == 2){
    return "approved-data";
  } else if(data.ckycStatus == 4 || data.ckycStatus == 3){
    return "rejected-data";
  } else{
    return "";
  }
}
export const farmStatusClassGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return '';
  } else if(data.farmStatus == 1 || data.farmStatus == 6){
    return "pending-data";
  } else if(data.farmStatus == 2){
    return "approved-data";
  } else if(data.farmStatus == 4 || data.farmStatus == 3){
    return "rejected-data";
  } else if(data.farmStatus == 5){
    return "hold-data";
  } else{
    return "";
  }
}
export const proposalStatusClassGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return '';
  } else if(data.proposalStatus == 1 || data.proposalStatus == 6){
    return "pending-data";
  } else if(data.proposalStatus == 2 || data.proposalStatus == 7){
    return "approved-data";
  } else if(data.proposalStatus == 3 || data.proposalStatus == 4){
    return "rejected-data";
  } else if(data.proposalStatus == 5){
    return "hold-data";
  } else{
    return "";
  }
}

export const getRoleStatusClass = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if(value === null || value === undefined) {
    return "";
  }
  else {
    return "role-status";
  }
}

export const getPermissionsClass = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if(!isValidString(value)) {
    return "";
  }
  else {
    return "permissions";
  }
}

export const amountValueGetter = (data: any, field?: string) => {
  return roundUpToTwoDecimals(data[field as keyof any]);
};

export const roundUpToTwoDecimals = (value: string) => {
  if(isValidString(value)){
    return parseFloat(value).toFixed(2);
  }
  else{
    return 'N/A';
  }
}

export const getGrievanceTypeData = (data: any) => {
  let filteredData = data.filter((each: any) => {
    if ((each.value >=7 && each.value <= 16) || each.value == 18) { return each }
  })
  return filteredData;
}

export const getLobData = (data: any) => {
  const allowedLOBs = new Set([1, 2, 5, 6])

  return data.map((each: any) => ({
    value: each.value,
    label: each.label,
    isDisabled: !allowedLOBs.has(each.value),
  }));
};

export const getUpdateLobData = (data: any) => {
  const allowedValues = new Set([1, 2, 5, 6, 7]);

  return data.map((each: any) => ({
    value: each.value,
    label: each.label,
    isDisabled: !allowedValues.has(each.value),
  }));
};


export const getDepartmentData = (data: any) => {
  return data.map((item: any) => ({
    label: item.value,
    value: item.id,
    status: item.status,
    lobId: item.lobId
  }));
}

export const getProductData = (data: any) => {
  return data.map((item: any) => ({
    label: item.productName,
    value: item.productId,
  }));
}

export const convertSeverityOptions = (data: any) => {
  return data.map((item: any) => ({
    label: item.severityName,
    value: item.severityId,
  }));
}

export const filterProducts = (data: any[], lob: any) => {
  const lobId = mapLOBMaster(lob);
  return data?.filter((each: any) => {
    if(lobId === LINE_OF_BUSINESS.HEALTH) return true;
    else if (
      lobId === LINE_OF_BUSINESS.CROP_RETAIL ||
      lobId === LINE_OF_BUSINESS.PMFBY ||
      lobId === LINE_OF_BUSINESS.RWBCIS
    ) {
      return PRODUCT_LOB_MAPPING[lobId]?.includes(each.value);
    }
    return true;
  });
};

export const convertMastersData = (data: any[]): { [key: string]: number } => {
  const result: { [key: string]: number } = {};
  data.forEach(item => {
      result[item.label] = item.value;
  });
  return result;
};

export const filterDepartments = (data: any[]) => {
  return data.filter((each: any) => {
    return (each?.label !== 'Super Admin' && checkNullValue(each?.lobId) !== 'N/A') || each?.label === 'GRO' || each?.label === 'To Be Assigned'
  })
}

export const displayRatingValue = (data: any) => {
  switch(data) {
    case '1': return '1 - Not Satisfied';
    case '2': return '2 - Partly Satisfied';
    case '3': return '3 - Satisfied';
    case '4': return '4 - Mostly Satisfied';
    case '5': return '5 - Fully Satisfied';
    default: return 'N/A'
  }
}

export const decodeHtml = (html: string, elementType: string) => {
  const txt = document.createElement(elementType);
  txt.innerHTML = html;
  return txt.innerText;
};

export const capitalizeFirstLetterValueGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return 'N/A';
  } 
  return capitalizeFirstLetter(data?.[field as any] ?? '');
}

/* Health */

export const healthKycStatusValueGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return 'N/A';
  } else if(data.ckycStatus === 0){
    return "Not Verified";
  } else if(data.ckycStatus === 1){
    return "Verified";
  } else{
    return "N/A";
  }
}

export const healthKycStatusClassGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return '';
  } else if(data.ckycStatus === 0){
    return "pending-data";
  } else if(data.ckycStatus === 1){
    return "approved-data";
  } else{
    return "";
  }
}



export const healthProposalStatusClassGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return '';
  } else if(data.proposalStatus === "No"){
    return "rejected-data";
  } else if(data.proposalStatus === "Yes"){
    return "approved-data";
  } else{
    return "";
  }
}

export const healthPolicyStatusValueGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return 'N/A';
  } else if(data.policyStatus === "true"){
    return "Policy Generated";
  } else if(data.policyStatus === "false"){
    return "Inactive";
  } else{
    return "N/A";
  }
}

export const healthPolicyStatusClassGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return '';
  } else if(data.policyStatus === "true"){
    return "approved-data";
  } else if(data.policyStatus === "false"){
    return "rejected-data";
  } else{
    return "";
  }
}

export const healthPaymentStatusValueGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return 'N/A';
  } else if(data.paymentStatus === "1"){
    return "Success";
  } else if(data.paymentStatus === "0"){
    return "Payment Not Done";
  } else{
    return "N/A";
  }
}

export const healthPaymentStatusClassGetter = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (!isValidString(value)) {
    return '';
  } else if(data.paymentStatus === "1"){
    return "approved-data";
  } else if(data.paymentStatus === "0"){
    return "pending-data";
  } else{
    return '';
  }
}

export const buildAdditionalInfo = (lobId: number | string, payload: any) => {
  let additionalInfo: any;
  switch(lobId) {
    case LINE_OF_BUSINESS.HEALTH: 
      additionalInfo = {
        policyType: payload?.additionalInfo?.policyType,
        policyTenure: payload?.additionalInfo?.policyTenure,
        cid: payload?.additionalInfo?.cid,
        memberId: payload?.additionalInfo?.memberId
      }
      return additionalInfo;
    default: 
      return payload.additionalInfo;
  }
}